module.exports = __webpack_public_path__ + "static/media/fvs_hamburgerKunsthalle_37.8063a49b.jpg";